//imports
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { HasPermission } from 'Core/security';

//views
import ListView from '../.template/views/list';
import DetailView from '../.template/views/detail';


export default () => {

	const user = useSelector(state => state.securityRedux.user);

	return (
		<Routes>
			{
				//Validate permissions send code, and subusers codes to validate "mntnnc-beta", [213]
				HasPermission(user, "", []) &&
				<>
					<Route path='/' element={<Navigate to="/app/template/list" />}></Route> 
					<Route path='list' element={<ListView />} />
					<Route path='detail/:id' element={<DetailView />} />
				</>
			}
			<Route path="*" element={<Navigate to="/app/error" />} />
		</Routes>
	);
};
